const initState = {
	isVisible : false,
	modalCoins : 0, 
	coinsType : 'time',
	name:'',
	alias:''
};

export default initState;
